import { Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import SignIn from './pages/SignIn';
import Uploader from './pages/Uploader';
import Chat from './pages/Chat';
import ProtectedRoute from './components/navigation/ProtectedRoute';
import DocumentManagment from './pages/DocumentManagment';
import SignUp from './pages/SignUp';
import Analytics from './pages/Analytics';
import UserManagement from './pages/UserManagment';
import ActivityLogs from './pages/ActivityLogs';
import Preferences from './pages/Preferences';
import CompanyManagement from './pages/CompanyManagement';

function App() {
    return (
        <Routes>
            <Route path="/" element={<SignIn />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route
                path="/dashboard"
                element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/upload"
                element={
                    <ProtectedRoute>
                        <Uploader />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/chat"
                element={
                    <ProtectedRoute>
                        <Chat />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/preferences"
                element={
                    <ProtectedRoute>
                        <Preferences />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/document-management"
                element={
                    <ProtectedRoute>
                        <DocumentManagment />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/user-management"
                element={
                    <ProtectedRoute>
                        <UserManagement />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/analytics"
                element={
                    <ProtectedRoute>
                        <Analytics />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/activity-logs"
                element={
                    <ProtectedRoute>
                        <ActivityLogs />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/company-management"
                element={
                    <ProtectedRoute>
                        <CompanyManagement />
                    </ProtectedRoute>
                }
            />
        </Routes>
    );
}

export default App;
